import React, { useEffect, useState } from 'react'
import { PasswordText, PasswordStatus, FormTextField } from '@emerald-works-nova/auth'
import { Grid } from '@mui/material'
import { Controller } from 'react-hook-form'

const PasswordInput = props => {
  const {
    control,
    formFields,
    validationStatus,
    passwordStrength,
    passwordRules,
    formState,
    trigger,
    setValue
  } = props

  const [showPassword, setShowPassword] = useState(true)

  // set password manually as hook does not account for default value
  useEffect(() => {
    setValue('password', 'Changeme1!*', { shouldDirty: true })
  }, [setValue])

  useEffect(() => {
    setTimeout(() => {
      const { password: passwordDidChange } = formState.dirtyFields
      passwordDidChange && trigger('password')
    })
  }, [passwordStrength, formState.dirtyFields, trigger])

  return (
    <>
      <Grid container direction='column' alignItems='center' spacing={2}>
        <Grid container item>
          <Controller
            name='password'
            control={control}
            rules={{
              required: { value: true, message: 'Required input' },
              validate: passwordRules
            }}
            render={({ field, fieldState: { isTouched, error } }) => {
              return (
                <FormTextField
                  type={showPassword ? 'text' : 'password'}
                  label='Default Password'
                  prefix='default'
                  name='password'
                  formFields={formFields(field)}
                  helperText={
                    <PasswordStatus
                      strength={passwordStrength}
                      status={validationStatus}
                      show={isTouched || error}
                    />
                  }
                  FormHelperTextProps={{ component: 'div' }}
                  end={
                    <PasswordText
                      disabled={!field.value}
                      showText={!showPassword}
                      onToggleShow={() => setShowPassword(!showPassword)}
                    />
                  }
                />
              )
            }}
          />
        </Grid>
      </Grid>
    </>
  )
}

export default PasswordInput
